import React from 'react';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import styles from './spinner.module.scss';

const Spinner: React.FC<React.HTMLProps<HTMLDivElement>> = (props) => {
  const { className, color = 'currentColor' } = props;

  return (
    <div className={clsx(styles.spinner, className)}>
      <Icon
        name="spinner-default"
        color={color}
        ariaHidden
      />
    </div>
  );
};

export default Spinner;
